import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initializeRuntimeConfig } from '@shared/config/runtime';
import { I18nProvider } from '@shared/i18n';
import { initializeObservability } from '@shared/observability/telemetry';
import { IgaGeonorgeApp } from './App';
import { en } from './i18n/en';
import { nb } from './i18n/nb';
import './theme/theme.css';

function resolveRouterBaseName(basePath: string): string | undefined {
  if (basePath === '/') {
    return undefined;
  }

  return basePath.replace(/\/$/, '');
}

const messages = import.meta.env.VITE_IGA_GEONORGE_LOCALE === 'en' ? en : nb;
const fallbackMessages = import.meta.env.VITE_IGA_GEONORGE_LOCALE === 'en' ? nb : en;

const runtimeConfig = initializeRuntimeConfig({
  variant: 'iga-geonorge',
  locale: messages.meta.locale,
});

initializeObservability();
document.documentElement.lang = runtimeConfig.app.locale;
document.body.classList.add('theme-iga-geonorge');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={resolveRouterBaseName(runtimeConfig.app.basePath)}>
      <I18nProvider
        locale={runtimeConfig.app.locale}
        messages={messages}
        fallbackMessages={fallbackMessages}
      >
        <IgaGeonorgeApp />
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>
);
